import React from 'react';
import { Cloud, Database, Cpu } from 'lucide-react';
import { ThreeAnimation } from './ThreeAnimation';
export const HeroSection = () => {
  return <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 text-white py-20 md:py-32 overflow-hidden" data-id="element-179">
      <div className="absolute inset-0" style={{
      height: '100%'
    }} data-id="element-180">
        <ThreeAnimation data-id="element-181" />
      </div>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-182">
        <div className="flex flex-col md:flex-row items-center" data-id="element-183">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-184">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6" data-id="element-185">
              Transform Your Business with Intelligent Cloud Solutions
            </h1>
            <p className="text-xl text-blue-100 mb-8" data-id="element-186">
              We specialize in cloud applications, SharePoint, Power Platform,
              data solutions, and AI development to drive your business forward.
            </p>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-187">
              <a href="#contact" className="bg-white text-blue-800 px-6 py-3 rounded-md text-lg font-medium hover:bg-blue-50 transition-colors text-center" data-id="element-188">
                Get Started
              </a>
              <a href="#services" className="bg-transparent border-2 border-white text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-white/10 transition-colors text-center" data-id="element-189">
                Learn More
              </a>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-190">
            <div className="relative h-64 w-64 md:h-80 md:w-80" data-id="element-191">
              <div className="absolute inset-0 rounded-full bg-blue-500/20 animate-pulse" data-id="element-192"></div>
              <div className="absolute top-0 right-0" data-id="element-193">
                <Cloud size={64} className="text-blue-300" data-id="element-194" />
              </div>
              <div className="absolute bottom-0 left-0" data-id="element-195">
                <Database size={64} className="text-blue-300" data-id="element-196" />
              </div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2" data-id="element-197">
                <Cpu size={80} className="text-blue-100" data-id="element-198" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};